import thunk from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import reducers, { initialState } from './ducks'
import api from './lib/api'

const DEBUGGER = (window.hasOwnProperty('__REDUX_DEVTOOLS_EXTENSION__') && typeof window.__REDUX_DEVTOOLS_EXTENSION__ === 'function') ? window.__REDUX_DEVTOOLS_EXTENSION__ : () => {}

export default function configureStore (history) {
  const store = createStore(
    reducers,
    initialState,
    applyMiddleware(
      thunk.withExtraArgument(api),
      routerMiddleware(history)
    ),
    DEBUGGER()
  )

  if (module.hot) {
    module.hot.accept('./ducks', () => {
      const nextReducer = require('./ducks')
      store.replaceReducer(nextReducer)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./store.js